import React from 'react'
import { Container, Grid, Typography, Button } from '@material-ui/core'
import useStyles from './style'
import CardItem from './CartItem/CartItem'
import { Link } from 'react-router-dom'

const Cart = ({cart,handleUpdateCartQty,handleRemoveFromCart,handleEmptyCart}) => {
  // console.log(cart)
  const classes = useStyles()
  const EmptyCart = () => (

    <Typography variant="subtitle1"> You have no items in your shopping cart,
    <Link className={classes.link} to="/">  start adding some  </Link>
    </Typography>
  );

  const FilterCart = () => (
    <>
      {/* <Typography variant="subtitle1">kkk</Typography> */}
      <Grid container spacing={3}>
        {cart.line_items.map(item => (
          <Grid item xs={12} sm={4} key={item.id}>
            <CardItem className={classes.cardItem} item={item}
             handleUpdateCartQty={handleUpdateCartQty}
             handleRemoveFromCart={handleRemoveFromCart}
             />
          </Grid>
        ))}
      </Grid>
      <div className={classes.cardDetails}>
            <Typography variant="h4">
              SubTotal: {cart.subtotal.formatted_with_symbol}
            </Typography>
            <div>
              <Button className={classes.emptyButton} size="large" type="button" variant="contained" color="secondary" onClick={handleEmptyCart}> Empty Cart </Button>
              <Button className={classes.checkoutButton} component={Link} to="/checkout" size="large" type="button" variant="contained" color="primary"> Checkout </Button>
            </div>
      </div>
    </>
  )

  if(!cart.line_items) return 'Loading....'

  return (
    <Container>
      <div className={classes.toolbar} />
      <Typography className={classes.title} variant="h3" gutterBottom > Your Shopping Cart </Typography>
      {!cart.line_items.length ? <EmptyCart/> : <FilterCart/>}
    </Container>
  )
}

export default Cart
